/* eslint-disable react/jsx-filename-extension, react/jsx-props-no-spreading */

import React from 'react';
import { render } from 'react-dom';

/**
 * React Component Manager
 *
 * Initialize React components on the fly and as many times as requested
 * on the page. Pass the dataset from the rendering element to the component
 * as properties.
 *
 * @param  {Object} components Object of component names and methods to render the components.
 */
export default function reactComponentManager(components) {
  const configureComponent = (componentName, Component) => {
    const targets = Array
      .from(document.querySelectorAll(`[data-react-component="${
        componentName
      }"]`))
      .filter((tar) => {
        const target = tar;

        // Prevent re-rendering component.
        if (target.dataset.componentInitialized) {
          return false;
        }

        target.dataset.componentInitialized = true;
        return true;
      });

    targets.forEach((target) => {
      render(
        <Component
          {...target.dataset}
        />,
        target,
      );
    });
  };

  Object.keys(components).forEach((component) => {
    configureComponent(component, components[component]);
  });
}
